import {useDataProvider} from "react-admin";
import React from "react";
import DebounceSelect from "../../../Common/DebounceSelect";

const MultiSelectWithFetch = ({ fetchResource, selectedItems, setSelectedItems }: { fetchResource: string, selectedItems: [], setSelectedItems: Function }) => {
    const dataProvider = useDataProvider();
    const fetchItemsList = async (values: string): Promise<any> => {
        return dataProvider.getList(
            fetchResource,
            {
                pagination: { page: 1, perPage: 0 },
                sort: { field: "name", order: "asc" },
                filter: {'name': values}
            }
        ).then((data: any) => data.data.map((result: any) => ({label: result.name, value: result.id})))
    }

    return (
        <DebounceSelect
            mode="multiple"
            showSearch
            placeholder="Select items"
            fetchOptions={fetchItemsList}
            value={selectedItems}
            onChangeSelect={newValue => setSelectedItems(newValue)}
            style={{ width: '200px' }}
        />
    )
}

export default MultiSelectWithFetch;
